module.exports = __webpack_public_path__ + "static/img/T1009_1.7d2dc0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T1009_1.png
// module id = xJlm
// module chunks = 64